import { useId } from 'react';
import css from './knowledge-base.module.scss';
import Filters from 'src/components/form/filters/filters';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import { KBFilterProps } from 'src/types';
import * as yup from 'yup';

function KnowledgeBaseFilter({ initialValues, onSubmit }: Readonly<KBFilterProps>) {
  const validationSchema = yup.object({
    search: yup.string().max(50, `Будь ласка, введіть запит довжиною до ${50} символів.`)
  });

  const inputId = useId();

  return (
    <Filters
      initialFilters={initialValues}
      validationSchema={validationSchema}
      fieldsToSubmitOnChange={['search']}
      onSearch={onSubmit}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.filterContainer}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder={'Шукати в базі знань...'}
            error={errors?.search?.message}
            inputProps={registerAndClearOnChange('search')}
          />
        </div>
      )}
    />
  );
}

export default KnowledgeBaseFilter;
